module.exports = __webpack_public_path__ + "img/05.0a0e5bec.jpg";